import { render } from "./Matches.vue?vue&type=template&id=744ae1b6&scoped=true"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"

import "./Matches.vue?vue&type=style&index=0&id=744ae1b6&scoped=true&lang=css"
import "./Matches.vue?vue&type=style&index=1&id=744ae1b6&scoped=true&lang=css"
import "./Matches.vue?vue&type=style&index=2&id=744ae1b6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744ae1b6"]])

export default __exports__